module.exports = __webpack_public_path__ + "static/profil_koncoworoczny_2021_8-682a1bf5d79287cd5608e01ba496651b.jpg";